var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { StyledExtendDropdown } from './style';
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isEmpty: false,
        };
        return _this;
    }
    Dropdown.getDerivedStateFromProps = function (props, state) {
        if (props.checkEmpty) {
            if (props.children && props.children.props) {
                if (Object.entries(props.children.props).length === 0) { // empty object
                    return { isEmpty: true };
                }
                if (props.children.props.children) {
                    var isEmpty = props.children.props.children.every(function (i) { return Boolean(i) === i && i === false; });
                    return { isEmpty: isEmpty };
                }
            }
            else if (props.options) {
                return { isEmpty: props.options.length === 0 };
            }
        }
        return null;
    };
    Dropdown.prototype.render = function () {
        var isEmpty = this.state.isEmpty;
        if (isEmpty) {
            return null;
        }
        return React.createElement(StyledExtendDropdown, __assign({}, this.props));
    };
    return Dropdown;
}(React.Component));
export default Dropdown;
//# sourceMappingURL=index.js.map